module.exports = __webpack_public_path__ + "img/beer_id-102.b642c058.png";